import { api as geoguesserApi } from './auto-generated/geoguesser'
import { api as eventApi } from './auto-generated/event'
import { RootState } from '@app/store'
import { createSocket } from './ws'

geoguesserApi.enhanceEndpoints({
  endpoints: {
    geoguesserJoinGame: {
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        dispatch(
          eventApi.util.updateQueryData('eventGetEventById', args, (draftEvent) => {
            draftEvent.event_type = 'GEO_GAME'
          }),
        )
        dispatch(
          eventApi.util.updateQueryData('eventGetCurrentEvent', undefined, (draftEvent) => {
            draftEvent.event_type = 'GEO_GAME'
          }),
        )
        try {
          await queryFulfilled
        } catch {}
      },
    },
    geoguesserGetAllGameResult: {
      async onCacheEntryAdded(arg, api) {
        const { tokens } = (api.getState() as RootState).auth
        const { eventId } = arg
        if (tokens && eventId) {
          let ws
          try {
            // wait for the initial query to resolve before proceeding
            await api.cacheDataLoaded
            const listener = (event: MessageEvent) => {
              const data = JSON.parse(event.data)
              switch (data.event_type) {
                case 'NEXT_ROUND':
                  api.dispatch(
                    geoguesserApi.endpoints.geoguesserGetAllGameResult.initiate(
                      {
                        eventId,
                      },
                      { forceRefetch: true },
                    ),
                  )
                  api.dispatch(
                    geoguesserApi.endpoints.geoguesserGetGameCoordinates.initiate(
                      {
                        eventId,
                      },
                      { forceRefetch: true },
                    ),
                  )
                  break
                default:
                  break
              }
            }
            ws = await createSocket(eventId, listener)
            // when data is received from the socket connection to the server,
            // if it is a message and for the appropriate channel,
            // update our query result with the received message
          } catch {
            // no-op in case `cacheEntryRemoved` resolves before `cacheDataLoaded`,
            // in which case `cacheDataLoaded` will throw
          }
          // cacheEntryRemoved will resolve when the cache subscription is no longer active
          await api.cacheEntryRemoved
          // perform cleanup steps once the `cacheEntryRemoved` promise resolves
          if (ws) {
            ws.close()
          }
        }
      },
    },
  },
})

export { geoguesserApi }
